module.exports = {
    RECEIVE_ALL_DATATYPES: 'RECEIVE_ALL_DATATYPES',
}
